import { useState } from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

interface HealtHistoryProps {
  user_health:
    | {
        name: string | null | undefined
        year: number | null | undefined
        status: string | undefined
        explanation: string | null | undefined
      }[]
    | undefined
}
export function HealthHistory(props: HealtHistoryProps) {
  const { user_health } = props
  const [show, setShow] = useState<boolean>(true)
  const idAccordion = 'health-history'
  return (
    <>
      <Accordion
        defaultValue={idAccordion}
        type="single"
        collapsible
        className="w-full rounded-md border-t-4 border-t-[#D91F2E] bg-white"
        onValueChange={(value) => setShow(value === idAccordion)}
      >
        <AccordionItem value={idAccordion} className="border-none p-0">
          <AccordionTrigger className="border-b border-b-[#EAECF0] p-6">
            <div className="flex w-full items-center justify-between">
              <div>Riwayat Kesehatan</div>
              <div className="text-xs">{show ? 'Sembunyikan' : ''}</div>
            </div>
          </AccordionTrigger>
          <AccordionContent className="w-full">
            {user_health?.length == 0 ? (
              <div className="flex justify-center p-4">Tidak ada data</div>
            ) : (
              <></>
            )}
            <div className="flex w-full flex-col gap-4 divide-y">
              {user_health?.map((t, key) => (
                <div className="grid w-full grid-cols-4 gap-4 p-6">
                  <div className="flex flex-col">
                    <div className="font-semibold">Riwayat Penyakit</div>
                    <div>{t.name}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Tahun Sakit</div>
                    <div>{t.year}</div>
                  </div>

                  <div className="flex flex-col">
                    <div className="font-semibold">Status Sakit</div>
                    <div>{t.status}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Keterangan</div>
                    <div>{t.explanation}</div>
                  </div>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  )
}
